import './styles.css'

import { observer } from 'mobx-react'
import React, { useState } from 'react'

import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'
import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import {
   ReactBaseModalContainer,
   useCustomT
} from '@flowwai-frontend/shared/common-components'
import {
   InfoFeaturedIcon,
   XCloseIcon
} from '@flowwai-frontend/design-system/icons'

import {
   deleteBoardViewContainer,
   deleteButtonsContainerClassName,
   descriptionStyles,
   headingAndDescriptionContainer,
   headingStyles,
   iconAndDeleteDetailsContainer,
   leaveButtonStyles
} from './styles'

interface SessionLogoutModalProps {
   isOpen?: boolean
   onCloseModal?: () => void
}

const SessionLogoutModal = (
   props: SessionLogoutModalProps
): React.ReactElement | null => {
   const { isOpen, onCloseModal: onCloseModalPropFunc } = props

   const { theme } = useAppTheme()
   const [isModalOpen, setIsModalOpen] = useState(false)

   const t = useCustomT('auth:sessionLogout')

   const logoutTheme = theme.auth.logout

   const onCloseModal = () => {
      setIsModalOpen(false)
      onCloseModalPropFunc && onCloseModalPropFunc()
   }

   const confirmationUITheme = theme.common.confirmationUI

   const renderSessionLogoutCard = () => (
      <div className={deleteBoardViewContainer}>
         <div className={iconAndDeleteDetailsContainer}>
            <div onClick={onCloseModal}>
               <InfoFeaturedIcon
                  width={48}
                  height={48}
                  fill={logoutTheme.infoIconColor}
                  outerBGColor={logoutTheme.infoIconOuterBgColor}
                  innerBgColor={logoutTheme.infoIconInnerBgColor}
               />
            </div>

            <div className={headingAndDescriptionContainer}>
               <span className={headingStyles(logoutTheme)}>{t('title')}</span>
               <span className={descriptionStyles(logoutTheme)}>
                  {t('description')}
               </span>
            </div>

            <div className={deleteButtonsContainerClassName}>
               <Button
                  hierarchy={Hierarchy.Primary}
                  subVariant={SubVariant.Primary}
                  size={'Large'}
                  className={leaveButtonStyles}
                  onClick={onCloseModal}
                  autoFocus
               >
                  {t('confirmText')}
               </Button>
            </div>
         </div>
      </div>
   )

   return (
      <ReactBaseModalContainer
         onClickCloseIcon={onCloseModal}
         isOpen={isModalOpen || isOpen}
         className={`session-logout-modal`}
         overlayClassName={'session-logout-overlay'}
         closeIconClass={'session-logout-modal-close-icon'}
         customCloseIcon={() => (
            <XCloseIcon
               height={24}
               width={24}
               fill={confirmationUITheme.closeIconColor}
            />
         )}
      >
         {renderSessionLogoutCard()}
      </ReactBaseModalContainer>
   )
}

export default observer(SessionLogoutModal)
